import { BookLayoutEnum } from '~/api/book/bookApiTypes';
import { catalogBookLayoutActions } from '~/feature/catalog/CatalogBookLayout/catalogBookLayout.slice';
import { getLocalStorageSafe } from '~/lib/utils/getLocalStorageSafe';
import { createAppThunk } from '~/store';

const GENRE_LAYOUT_NAME = 'genre_layout';

export const changeSavedLayout = createAppThunk<boolean, BookLayoutEnum>(
  'changeSavedLayout',
  (layout, thunkAPI) => {
    const storage = getLocalStorageSafe();
    if (storage) {
      try {
        storage.setItem(GENRE_LAYOUT_NAME, layout);
        thunkAPI.dispatch(catalogBookLayoutActions.changeLayout(layout));
        return true;
      } catch (error) {
        console.error('Failed to save genre layout:', error);
      }
    }
    return false;
  },
);

export const loadGenreLayout = createAppThunk<void, void>(
  'loadGenreLayout',
  (_, thunkAPI) => {
    const storage = getLocalStorageSafe();
    if (storage) {
      try {
        const layout = storage.getItem(GENRE_LAYOUT_NAME) as BookLayoutEnum;
        if (layout) {
          thunkAPI.dispatch(catalogBookLayoutActions.changeLayout(layout));
        }
      } catch (error) {
        console.error('Failed to load genre layout:', error);
      }
    }
  },
);
